import { v4 } from 'uuid';

import { RecordData } from '../../helpers-classes';
import { ConnectionData, ConnectionDataIn, ConnectionParams } from './types';

export const connectionData = (params: ConnectionParams | null = null, dataIn: ConnectionDataIn = null): ConnectionData => {
	const { id = null,
		isSource = false,
		verticalAlign = null,
		horizontalAlign = null,
		alignToPanel = false,
		padding = 0,
		offset = 0,
		sourcePanelId = null,
		targetIslandId = null } = params || {};
	const rd = new RecordData<ConnectionDataIn>(dataIn);

	const record: ConnectionData = {
		id: rd.useNewOrPartial<string>('id', id || v4()),
		isSource: rd.useNewOrDefault('isSource', isSource),
		verticalAlign: rd.useNewOrDefault('verticalAlign', verticalAlign),
		horizontalAlign: rd.useNewOrDefault('horizontalAlign', horizontalAlign),
		alignToPanel: rd.useNewOrDefault('alignToPanel', alignToPanel),
		padding: rd.useNewOrDefault('padding', padding),
		offset: rd.useNewOrDefault('offset', offset),
		sourcePanelId: rd.useNewOrDefault('sourcePanelId', sourcePanelId),
		targetIslandId: rd.useNewOrDefault('targetIslandId', targetIslandId)
	};

	return record;
};
